import { colorBaseGreyWarm50, layoutMarginMedium } from '@issuu/silkscreen';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { shouldShowAds } from '../../util/ads-utils';
import { isLayoutOneOf } from '../../util/layoutUtils';
import { AdsDocumentDetail } from '../Ads';
import DocumentContext from '../DocumentPage/DocumentContext';
import type { GridLayout } from '../DocumentPage/useGridLayout';
import { ScreenReaderH2 } from '../ScreenReaderOnly';
import { Categories } from './Categories';
import { Description } from './Description';
import { PublishDate } from './PublishDate';
import { PublisherDetails } from './PublisherDetails';
import { Title } from './Title';

const Root = styled.div`
    padding: ${layoutMarginMedium};
    width: 100%;
    background-color: ${colorBaseGreyWarm50};
    display: flex;
    justify-content: space-between;
`;

const largeLayouts: GridLayout[] = ['singleColumn', 'twoColumn', 'wideScreen'];

const Wrapper = styled.div`
    flex-shrink: 1;
    min-width: 0;
`;

export const DocumentDetails: React.FC = () => {
    const context = useContext(DocumentContext);
    const {
        appState: {
            currentLayout: { name: layout },
        },
    } = context;
    const isLarge = isLayoutOneOf(largeLayouts, layout);
    const isTiny = layout === 'tiny';
    return (
        <Root>
            {isTiny ? null : <ScreenReaderH2>Document details</ScreenReaderH2>}
            <Wrapper>
                {isTiny ? null : <Title />}
                {isLarge ? <PublishDate /> : null}
                <Description />
                <Categories />
                {isTiny ? null : <PublisherDetails isLarge={isLarge} />}
            </Wrapper>
            {isLarge && shouldShowAds({ context }) ? <AdsDocumentDetail /> : null}
        </Root>
    );
};
